(() => {
  const scrollToElement = (element) => {
    if (!element) return;
    element.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'center' });
  };
  if (!customElements.get('rangeup-sticky-atc')) {
    customElements.define('rangeup-sticky-atc', class extends HTMLElement {
      connectedCallback() {
        this.productInfo = this.closest('product-info');
        this.mainButton = this.productInfo?.querySelector('[id^="ProductSubmitButton-"]');
        if (!this.mainButton) return;
        this.add = this.querySelector('.rangeup-sticky__add');
        this.onAdd = () => {
          const form = this.mainButton.closest('form');
          if (!this.mainButton.disabled && form) form.requestSubmit(this.mainButton);
        };
        this.onOptions = () => { const picker=this.productInfo.querySelector('variant-selects'); scrollToElement(picker); picker?.querySelector('input,select,button')?.focus({preventScroll:true}); };
        this.add.addEventListener('click', this.onAdd);
        this.querySelector('.rangeup-sticky__options')?.addEventListener('click',this.onOptions);
        this.sync = () => {
          const original=this.productInfo.querySelector('[id^="ProductSubmitButton-"]');
          if (!original) return;
          this.mainButton=original;
          this.add.disabled=original.disabled || original.getAttribute('aria-disabled') === 'true';
          this.add.textContent=original.querySelector('span')?.textContent.trim() || original.textContent.trim();
          const price=this.productInfo.querySelector('[id^="price-"] .price');
          if(price) this.querySelector('.rangeup-sticky__price').innerHTML=price.innerHTML;
        };
        this.sync();
        this.mutations=new MutationObserver(this.sync);
        // Observe Dawn's form/price changes without observing the sticky copy.
        this.productInfo.querySelectorAll('[id^="price-"], product-form').forEach(el => this.mutations.observe(el,{childList:true,subtree:true,attributes:true}));
        this.onScroll=()=>{ this.hidden=this.mainButton.getBoundingClientRect().bottom>=0; };
        window.addEventListener('scroll',this.onScroll,{passive:true});this.onScroll();
      }
      disconnectedCallback(){this.mutations?.disconnect();window.removeEventListener('scroll',this.onScroll);this.add?.removeEventListener('click',this.onAdd);this.querySelector('.rangeup-sticky__options')?.removeEventListener('click',this.onOptions);}
    });
  }
  function initialize(root=document){
    root.querySelectorAll('.rangeup-toc:not([data-ready])').forEach(nav=>{
      nav.dataset.ready='true';const article=nav.closest('article');const list=nav.querySelector('ol');
      article?.querySelectorAll('.article-template__content h2,.article-template__content h3').forEach((heading,index)=>{
        if(!heading.id) heading.id=`rangeup-heading-${index+1}`;
        const li=document.createElement('li'),a=document.createElement('a');a.href=`#${heading.id}`;a.textContent=heading.textContent;li.append(a);list.append(li);
      });nav.hidden=!list.children.length;
    });
    root.querySelectorAll('.rangeup-track form:not([data-ready])').forEach(form=>{
      form.dataset.ready='true';form.addEventListener('submit',e=>{
        e.preventDefault();const number=form.querySelector('input').value.trim();if(!number)return;
        if(window.YQV5) window.YQV5.trackSingle({YQ_ContainerId:'RangeUpTrackingResults',YQ_Height:560,YQ_Fc:'0',YQ_Lang:'en',YQ_Num:number});
        else window.open(`https://t.17track.net/en#nums=${encodeURIComponent(number)}`,'_blank','noopener');
      });
    });
  }
  document.addEventListener('DOMContentLoaded',()=>{
    initialize();const top=document.querySelector('.rangeup-back-top');
    top?.addEventListener('click',()=>window.scrollTo({top:0,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'}));
    const update=()=>{if(top)top.hidden=window.scrollY<400;const bar=document.querySelector('.rangeup-reading-progress');if(bar){const total=document.documentElement.scrollHeight-innerHeight;bar.style.width=`${total>0?Math.min(100,window.scrollY/total*100):0}%`;}};
    window.addEventListener('scroll',update,{passive:true});update();
  });
  document.addEventListener('shopify:section:load',event=>initialize(event.target));
})();
